import { render, staticRenderFns } from "./NoItemsContainer.vue?vue&type=template&id=2d02d5dc"
import script from "./NoItemsContainer.vue?vue&type=script&lang=js"
export * from "./NoItemsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports